import React from 'react';
import logobiz from 'assets/img/biz-capital-logo-2019.png';
import poligono from 'assets/img/poligono.png';
import estimulo from 'assets/img/estimulo2020.png';
import Footer from '../footer/footer';
import { BizonSteps } from 'components/commons';
import { PartnerLogo } from '../header/layouts';
import { ProfileConsumer } from 'providers/profile.provider';
import { ESTIMULO_BRAND, POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';
import './bizon-checkout-wrapper.styles.scss';

const BizonPartnerLogo: React.FC = (): JSX.Element => {
    const brand = getProductBrand();

    switch (brand.branchName) {
        case POLIGONO_BRAND.branchName:
            return <img src={poligono} alt="poligono-logo" className="poligono-logo" />;
        case ESTIMULO_BRAND.branchName:
            return <img src={estimulo} alt="estimulo-logo" className="estimulo-logo" />;
        default:
            return (
                <ProfileConsumer>
                    {({ isPartner, logo }) => (
                        isPartner !== true
                            ? <img src={logobiz} alt="bizcap-logo" />
                            : <PartnerLogo url={logo} />
                    )}
                </ProfileConsumer>
            );
    }
};

const BizonCheckoutWrapper: React.FC = ({ children }): JSX.Element => {
    return (
        <>
            <div className="bizon-checkout-wrapper">
                <div className="bizon-checkout-wrapper__left-fill" />
                <div className="bizon-checkout-wrapper__middle">
                    <div className="bizon-checkout-wrapper__header grid-container">
                        <div className="bizon-checkout-wrapper__logo">
                            <BizonPartnerLogo />
                        </div>
                        <div className="bizon-checkout-wrapper__steps">
                            <BizonSteps />
                        </div>
                    </div>
                    <div className="bizon-checkout-wrapper__content">
                        {children}
                    </div>
                </div>
                <div className="bizon-checkout-wrapper__right-fill">
                    <div className="bizon-checkout-wrapper__right-fill--footer" />
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BizonCheckoutWrapper;
